import { styled } from "@health-zelas/delta"

export const Wrapper = styled('div', {
  textAlign: 'center',
  marginTop: '$xhuge',

  '@md': {
    textAlign: 'start',
  }
})
